import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box, Container, TextField, Typography } from "@material-ui/core";
import "../AdminCommonPages.css";
import axios from "axios";

const AddVehicleType = ({ isShaws }) => {
  //   const classes = useStyles();
  const [vehicleTypes, setVehicleTypes] = useState({
    vehicleType: undefined,
  });
  const handleChange = (e) => {
    setVehicleTypes((prv) => ({
      ...prv,
      [e.target.id]: e.target.value,
    }));
  };
  const notify = () => {
    toast.success("Success Notification !", {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const handleClick = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        "https://abc-backend.onrender.com/api/vehicles/vehicle",
        vehicleTypes
      );
      if (vehicleTypes) {
        notify();
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className={"type_main"}>
      <Container>
        <Typography variant="h2">Add Vehicle Type</Typography>
        <Box>
          <form noValidate autoComplete="off" className="type_form">
            <Box>
              <label htmlFor="">Container Truck Type</label>
              <br />
              <br />
              <TextField
                id="vehicleType"
                variant="outlined"
                onChange={handleChange}
              />
            </Box>
            <Box className="type_submit_btn">
              <button className="common-btn" onClick={handleClick}>
                Add
              </button>
            </Box>
          </form>
        </Box>
        {/* Same as */}
        <ToastContainer />
      </Container>
    </div>
  );
};

export default AddVehicleType;
